import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/starIcon.svg'


const _hoisted_1 = { class: "grey-box" }
const _hoisted_2 = { class: "checkout-page-item" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "checkout-page-item-info" }
const _hoisted_5 = { class: "body-text-bold" }
const _hoisted_6 = { class: "body-text-bold" }
const _hoisted_7 = { class: "body-text-bold" }
const _hoisted_8 = { class: "body-text-bold primary-text" }
const _hoisted_9 = { class: "checkout-page-form-box" }
const _hoisted_10 = { class: "title-text" }
const _hoisted_11 = { class: "checkout-page-form-box-row" }
const _hoisted_12 = { class: "checkout-page-form-box-row" }
const _hoisted_13 = { class: "checkout-page-form-box" }
const _hoisted_14 = { class: "title-text" }
const _hoisted_15 = { class: "checkout-page-form-box-row" }
const _hoisted_16 = { class: "checkout-page-form-box" }
const _hoisted_17 = {
  key: 0,
  class: "small-list-text error-text"
}
const _hoisted_18 = { class: "checkout-page-form-box-radios" }
const _hoisted_19 = { for: "paymentMethod1" }
const _hoisted_20 = { class: "label-hidden-text" }
const _hoisted_21 = { class: "label-text" }
const _hoisted_22 = { for: "paymentMethod2" }
const _hoisted_23 = { class: "label-hidden-text" }
const _hoisted_24 = { class: "label-text" }
const _hoisted_25 = { class: "checkout-page-form-box-checkboxes" }
const _hoisted_26 = { for: "termsAndConditions" }
const _hoisted_27 = { class: "list-text" }
const _hoisted_28 = {
  key: 0,
  class: "required-text"
}
const _hoisted_29 = { class: "checkbox" }
const _hoisted_30 = { for: "newsletter" }
const _hoisted_31 = {
  class: "button",
  type: "submit"
}

import { generalStore } from '@/store';
import { ref, computed, nextTick, onMounted } from 'vue';
import InputComponent from '@/components/form-components/InputComponent.vue';
import { useRouter } from 'vue-router';
import { useVuelidate, ValidationRule } from '@vuelidate/core';
import { email, required, sameAs } from '@vuelidate/validators';
import axios from 'axios';
import NotFoundComponent from '@/components/NotFoundComponent.vue';
import __ from '@/translate';


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckoutPage',
  setup(__props) {

const store = generalStore();
const product = ref();
const router = useRouter();
const quantity = ref();
const submitted = ref(false);
const checkoutFormData = ref({
  name: '',
  surname: '',
  address: '',
  postal: '',
  city: '',
  email: '',
  phone: '',
  paymentMethod: '',
  newsletter: false,
  termsAndConditions: false,
  productId: parseInt(router.currentRoute.value.params.id.toString()),
  amount: 0,
  comment: '',
});
const notFound = ref(false);

const validationRules = computed(() => {
  const localRules: Record<string, Record<string, ValidationRule>> = {};

  localRules.name = {
    required,
  };

  localRules.surname = {
    required,
  };

  localRules.email = {
    required,
    email,
  };

  localRules.phone = {
    required,
  };

  localRules.address = {
    required,
  };

  localRules.city = {
    required,
  };

  localRules.postal = {
    required,
  };

  localRules.paymentMethod = {
    required,
  };

  localRules.termsAndConditions = {
    required,
    mustBeTrue: sameAs(true),
  };

  return localRules;
});

const validation = useVuelidate(validationRules, checkoutFormData);

function submitPayment() {
  validation.value.$touch();
  if (validation.value.$invalid) {
    nextTick(() => {
      const firstInvalidInput = document.querySelector('.is-invalid');
      if (firstInvalidInput) {
        window.scrollTo({
          top: firstInvalidInput.getBoundingClientRect().top + window.scrollY - 100,
          behavior: 'smooth',
        });
      }
    });
    return;
  }

  if (submitted.value) {
    return;
  }
  submitted.value = true;

  axios
    .post('/api/orders', checkoutFormData.value)
    .then((response) => {
      if (checkoutFormData.value.paymentMethod === 'stripe') {
        router.push({
          name: 'StripePaymentPage',
          params: {
            uuid: response.data.uuid,
          },
        });
      } else {
        router.push({ name: 'OrderSuccessPage', params: { uuid: response.data.uuid } });
      }
    })
    .catch(() => {
      router.push({ name: 'PaymentFailedPage' });
    })
    .finally(() => {
      submitted.value = false;
    });
}

onMounted(() => {
  fetchProductDetails().then(() => {
    if (router.currentRoute.value.params.quantity) {
      quantity.value = router.currentRoute.value.params.quantity;
    } else {
      quantity.value = 1;
    }

    checkoutFormData.value.amount = parseInt(quantity.value);
  });
});

function fetchProductDetails() {
  return axios
    .get(`/api/products/${router.currentRoute.value.params.id}`)
    .then((response) => {
      product.value = response.data;
    })
    .catch(() => {
      notFound.value = true;
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (product.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                src: product.value.imageUrl,
                class: "checkout-page-item-image"
              }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(product.value.name), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(store).formatPrice(product.value.price)), 1),
                _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(__)('item_quantity')) + ": " + _toDisplayString(quantity.value), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(store).formatPrice(product.value.price * quantity.value)), 1)
              ])
            ])
          ]),
          _createElementVNode("form", {
            class: "checkout-page-form",
            onSubmit: _withModifiers(submitPayment, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(__)('your_information')), 1),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(InputComponent, {
                  autocomplete: 'given-name',
                  modelValue: checkoutFormData.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkoutFormData.value.name) = $event)),
                  placeholder: _unref(__)('form_name'),
                  "error-message": _unref(validation).name.$error ? _unref(__)('form_required') : '',
                  class: _normalizeClass({
              'is-invalid': _unref(validation).name.$error,
            })
                }, null, 8, ["modelValue", "placeholder", "error-message", "class"]),
                _createVNode(InputComponent, {
                  autocomplete: 'family-name',
                  modelValue: checkoutFormData.value.surname,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checkoutFormData.value.surname) = $event)),
                  placeholder: _unref(__)('form_surname'),
                  "error-message": _unref(validation).surname.$error ? _unref(__)('form_required') : '',
                  class: _normalizeClass({
              'is-invalid': _unref(validation).surname.$error,
            })
                }, null, 8, ["modelValue", "placeholder", "error-message", "class"])
              ]),
              _createVNode(InputComponent, {
                autocomplete: 'address-line1',
                modelValue: checkoutFormData.value.address,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((checkoutFormData.value.address) = $event)),
                placeholder: _unref(__)('form_adress'),
                "error-message": _unref(validation).address.$error ? _unref(__)('form_required') : '',
                class: _normalizeClass({
            'is-invalid': _unref(validation).address.$error,
          })
              }, null, 8, ["modelValue", "placeholder", "error-message", "class"]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(InputComponent, {
                  autocomplete: 'address-level2',
                  modelValue: checkoutFormData.value.city,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((checkoutFormData.value.city) = $event)),
                  placeholder: _unref(__)('form_city'),
                  "error-message": _unref(validation).city.$error ? _unref(__)('form_required') : '',
                  class: _normalizeClass({
              'is-invalid': _unref(validation).city.$error,
            })
                }, null, 8, ["modelValue", "placeholder", "error-message", "class"]),
                _createVNode(InputComponent, {
                  autocomplete: 'postal-code',
                  modelValue: checkoutFormData.value.postal,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((checkoutFormData.value.postal) = $event)),
                  placeholder: _unref(__)('form_postal_code'),
                  "error-message": _unref(validation).postal.$error ? _unref(__)('form_required') : '',
                  class: _normalizeClass({
              'is-invalid': _unref(validation).postal.$error,
            })
                }, null, 8, ["modelValue", "placeholder", "error-message", "class"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(__)('contact_information')), 1),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(InputComponent, {
                  autocomplete: 'email',
                  modelValue: checkoutFormData.value.email,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((checkoutFormData.value.email) = $event)),
                  placeholder: _unref(__)('form_email'),
                  "input-type": 'email',
                  "error-message": _unref(validation).email.$error ? _unref(__)('form_required') : '',
                  class: _normalizeClass({
              'is-invalid': _unref(validation).email.$error,
            })
                }, null, 8, ["modelValue", "placeholder", "error-message", "class"]),
                _createVNode(InputComponent, {
                  autocomplete: 'tel',
                  modelValue: checkoutFormData.value.phone,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((checkoutFormData.value.phone) = $event)),
                  placeholder: _unref(__)('form_phone'),
                  "input-type": 'tel',
                  "error-message": _unref(validation).phone.$error ? _unref(__)('form_required') : '',
                  class: _normalizeClass({
              'is-invalid': _unref(validation).phone.$error,
            })
                }, null, 8, ["modelValue", "placeholder", "error-message", "class"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", {
                class: _normalizeClass(["title-text", {
            'error-text': _unref(validation).paymentMethod.$error,
          }])
              }, [
                _createTextVNode(_toDisplayString(_unref(__)('payment_method')) + " ", 1),
                (_unref(validation).paymentMethod.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(__)('form_required')), 1))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: _normalizeClass(["radio", {
              'is-invalid': _unref(validation).paymentMethod.$error,
            }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "paymentMethod1",
                    name: "paymentMethod",
                    value: "stripe",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((checkoutFormData.value.paymentMethod) = $event))
                  }, null, 512), [
                    [_vModelRadio, checkoutFormData.value.paymentMethod]
                  ]),
                  _createElementVNode("label", _hoisted_19, [
                    _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(__)('checkout_option_card')), 1),
                    _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(__)('checkout_option_card')), 1)
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["radio", {
              'is-invalid': _unref(validation).paymentMethod.$error,
            }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "paymentMethod2",
                    name: "paymentMethod",
                    value: "delivery",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((checkoutFormData.value.paymentMethod) = $event))
                  }, null, 512), [
                    [_vModelRadio, checkoutFormData.value.paymentMethod]
                  ]),
                  _createElementVNode("label", _hoisted_22, [
                    _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(__)('checkout_option_delivery')), 1),
                    _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(__)('checkout_option_delivery')), 1)
                  ])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", {
                  class: _normalizeClass(["checkbox", {
              'is-invalid': _unref(validation).termsAndConditions.$error,
            }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "termsAndConditions",
                    value: true,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((checkoutFormData.value.termsAndConditions) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, checkoutFormData.value.termsAndConditions]
                  ]),
                  _createElementVNode("label", _hoisted_26, [
                    _createElementVNode("p", _hoisted_27, [
                      _createTextVNode(_toDisplayString(_unref(__)('terms_and_conditions_payment')) + " ", 1),
                      (_unref(validation).termsAndConditions.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_unref(__)('form_required')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "newsletter",
                    value: true,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((checkoutFormData.value.newsletter) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, checkoutFormData.value.newsletter]
                  ]),
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(__)('newsletter_text')), 1)
                ])
              ]),
              _createElementVNode("button", _hoisted_31, [
                _cache[11] || (_cache[11] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_unref(__)('product_buy')), 1)
              ])
            ])
          ], 32)
        ], 64))
      : _createCommentVNode("", true),
    (notFound.value)
      ? (_openBlock(), _createBlock(NotFoundComponent, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})